/** Раздел E: азартные мини-игры E1–E6 (interactives.md). */
import type { MinigameDef } from '../types';
import { bets } from './bets';
import { blackjack } from './blackjack';
import { dice } from './dice';
import { lottery } from './lottery';
import { roulette } from './roulette';
import { slots } from './slots';

export const CASINO_MINIGAMES: MinigameDef[] = [
  lottery as MinigameDef,
  roulette as MinigameDef,
  slots as MinigameDef,
  blackjack as MinigameDef,
  dice as MinigameDef,
  bets as MinigameDef,
];

export { lottery, roulette, slots, blackjack, dice, bets };
